<div style="height: 800px; margin-top: 16px">
  <ng2-pdfjs-viewer [pdfSrc]="pdfSrc"></ng2-pdfjs-viewer>
</div>
